// extracted by mini-css-extract-plugin
export default {"main":"a30e07"};